import { render, staticRenderFns } from "./PriceTypeEdit.vue?vue&type=template&id=140fae1f"
import script from "./PriceTypeEdit.vue?vue&type=script&lang=js"
export * from "./PriceTypeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports